import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import './Admin.css';
const API_URL = process.env.REACT_APP_API_URL;
const PendingPayoutsPage = () => {
  const { t, i18n } = useTranslation();
  const { token } = useAuth();
  
  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchPayouts = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true); setError('');
      const response = await fetch(`${API_URL}/api/admin/translators/pending-payouts`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error(t('error_fetch_payouts', 'Ödeme listesi alınamadı.'));
      const data = await response.json();
      setPayouts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token, t]);

  useEffect(() => {
    fetchPayouts();
  }, [fetchPayouts]);
  
  const formatCurrency = (amount) => {
      return parseFloat(amount || 0).toLocaleString(i18n.language, {style:'currency', currency:'TRY'});
  };

  if (loading) return <div className="page-container"><i className="fas fa-spinner fa-spin"></i> {t('loading_payouts', 'Ödemeler Yükleniyor...')}</div>;
  if (error) return <div className="page-container error">{error}</div>;

  return (
     <div className="page-container admin-dashboard">
        <div className="page-header modern">
            <h1>{t('pending_payouts')}</h1>
  
        </div>
     
      
      <div className="admin-table-container">
        <table className="admin-table">
          <thead>
            <tr>
              <th>{t('translator_check')}</th>
              <th>{t('current_balance_table')}</th>
              <th>{t('actions')}</th>
            </tr>
          </thead>
          <tbody>
            {payouts.length > 0 ? payouts.map(payout => (
              <tr key={payout.id}>
                <td>{payout.first_name} {payout.last_name}</td>
                <td>{formatCurrency(payout.current_balance)}</td>
                <td>
                  <Link to={`/management/translators/${payout.id}`} className="action-btn view">
                    <i className="fas fa-dollar-sign"></i> {t('process_payment', 'Ödemeyi İşle')}
                  </Link>
                </td>
              </tr>
            )) : <tr><td colSpan="3" className="empty-row">{t('no_pending_payouts', 'Ödeme eşiğini geçen çevirmen bulunmamaktadır.')}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PendingPayoutsPage;